import { formatNumber, formatRate, visibleResources } from '../../engine';
import type { Snapshot } from '../../game/store';
import { Glyph } from '../Glyph';

interface ResourceBarProps {
  snapshot: Snapshot;
}

export function ResourceBar({ snapshot }: ResourceBarProps) {
  const { state, production } = snapshot;
  const views = visibleResources(state, production);
  const notation = state.settings.notation;
  const showRates = state.settings.showRates;

  const materials = views.filter((view) => !view.def.isCurrency);
  const currencies = views.filter((view) => view.def.isCurrency);
  const ordered = [...currencies, ...materials];

  if (ordered.length === 0) {
    return (
      <section className="panel">
        <p className="empty-note">The tribe carries nothing yet.</p>
      </section>
    );
  }

  return (
    <section className="panel">
      <div className="resource-grid">
        {ordered.map((view) => {
          const fillPercent = Number.isFinite(view.cap)
            ? Math.min(100, (view.amount / view.cap) * 100)
            : 0;

          return (
            <div
              key={view.def.id}
              className={`resource${view.isFull ? ' full' : ''}`}
              title={view.def.description}
            >
              <Glyph id={view.def.glyph} size={20} tone={view.def.isCurrency ? 'bone' : 'ochre'} />
              <div>
                <div className="resource-name">{view.def.name}</div>
                <div>
                  <span className="resource-amount">{formatNumber(view.amount, notation)}</span>
                  {Number.isFinite(view.cap) && !view.def.isCurrency ? (
                    <span className="resource-cap"> / {formatNumber(view.cap, notation)}</span>
                  ) : null}
                </div>
                {showRates ? (
                  <div className={`resource-rate${view.net < 0 ? ' negative' : ''}`}>
                    {formatRate(view.net, notation)}
                  </div>
                ) : null}
                {Number.isFinite(view.cap) && !view.def.isCurrency ? (
                  <div className="bar" style={{ marginTop: 4 }}>
                    <div
                      className={`bar-fill${view.isFull ? ' rust' : ''}`}
                      style={{ width: `${fillPercent}%` }}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
